export default "__VITE_ASSET__e838272a__"